import { render, staticRenderFns } from "./download-form.vue?vue&type=template&id=097f5332&scoped=true&lang=pug"
import script from "./download-form.vue?vue&type=script&lang=js"
export * from "./download-form.vue?vue&type=script&lang=js"
import style0 from "./download-form.vue?vue&type=style&index=0&id=097f5332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097f5332",
  null
  
)

export default component.exports